import BookDemoForm, { getServerSidePropsFunc } from '../bookafreehomedemo';
export default BookDemoForm;
export const getServerSideProps = getServerSidePropsFunc('/forbesairpurifier/book-a-demo');
